export const SECTION_COVER_PRESETS = 4;
export const SECTION_COLOR_SHAPE_STATUS_0 = 'CCD6E0';
export const SECTION_COLOR_SHAPE_STATUS_1 = 'C3E0FF';
export const SECTION_COLOR_SHAPE_STATUS_2 = '95C8FF';
export const SECTION_COLOR_SHAPE_STATUS_3 = '57A4F7';
export const SECTION_COLOR_SHAPE_STATUS_4 = '026CDF';
export const SECTION_COLOR_OUTLINE_HOVER = '000000';
export const SECTION_COLOR_INTERIOR_HOVER = 'ffffff';
